import api from './api';

export const fetchData = async ({ startDate, endDate, year_to_compare = 2024, endpoint, hurto_type = null }) => {
  try {
    const params = new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
      year_to_compare: year_to_compare
    });
    if (endpoint === 'hurtos/' && hurto_type) {
      params.append('hurto_type', hurto_type);
    }
    const response = await api.get(`/${endpoint}?${params}`);
    return response.data;
  } catch (error) {
    console.error('Error al cargar datos de ${endpoint}:', error);
    throw new Error('Error al cargar datos de ${endpoint}');
  }
};

export default { fetchData };